<template>

                  <!-- 手机验证码登录 -->
                  <el-form class="login-form">
                    <el-form-item>
                      <sw-input v-model="mobile" size="defualt" :placeholder="i18n['screen.welcome.label.mobile.placeholder']||'请输入绑定的手机号'" circular>
                        <i slot="prefix" class="su-input-icon black su-input-icon-prefix el-input__icon su-icon-phone"></i>
                      </sw-input>
                    </el-form-item>
                    <el-form-item class="relative" >
                      <sw-input v-model="dynamiccode" size="defualt" :placeholder="i18n['screen.welcome.label.dynamiccode.placeholder']||'请输入验证码'" circular class="su-input-text-button"  @keyup.enter.native="smsCodeLogin(mobile, dynamiccode)">
                        <i slot="prefix" class="su-input-icon black su-input-icon-prefix el-input__icon su-icon-dyncode"></i>
                        <el-button slot="append" @click="smsCodeSend(mobile)">{{sendButtonText}}</el-button>
                      </sw-input>
                      <div class="login-error" v-if="loginError">
                        {{loginError}}
                      </div>
                    </el-form-item>

                    <el-form-item>
                      <el-button @click="smsCodeLogin(mobile, dynamiccode)" class="login-btn" size="defualt" style="width: 100%" type="primary" native-type="button" round>{{i18n['screen.welcome.button.login']||'登 录'}}</el-button>
                    </el-form-item>
                  </el-form>

</template>

<script>
export default {
  props: [
    'i18n',
    'config',

    'sendButtonDisable',
    'sendButtonText',

    'mobile', 
    'dynamiccode', 

    'loginError',
  ],
  data: function data() {
    return {
    }
  },
  created: function created() {
  },
  mounted: function mounted() {
  },
  methods:{
  }
}
</script>
